import { useQuery } from "@tanstack/react-query";
import {
  getSystemRecentKills,
  type SystemRecentKills,
} from "../api/systems";

export function useSystemRecentKills(systemId: string | null | undefined) {
  return useQuery<SystemRecentKills>({
    queryKey: ["systems", systemId, "recent-kills"],
    queryFn: () => getSystemRecentKills(systemId as string),
    enabled: !!systemId,
    retry: 1,
    staleTime: 30_000,
  });
}
